

import { useState, useEffect } from "react";

export const useUserId = () => {
  const [Userid, setUserId] = useState<string | null>(
    localStorage.getItem("useR_ID")?.replace(/^"|"$/g, "") || null
  );

  useEffect(() => {
    const handleStorageChange = () => {
      setUserId(localStorage.getItem("useR_ID")?.replace(/^"|"$/g, "") || null);
    };

    window.addEventListener("storage", handleStorageChange);
    
    return () => {
      window.removeEventListener("storage", handleStorageChange);
    };
  }, []);

  return [Userid, setUserId] as const;
};


export function getISTDate() {
  const someDate = new Date();
  const istOffset = 5.5 * 60 * 60 * 1000;

  const istDate = new Date(someDate.getTime() + istOffset);

  const defaultValues = istDate.toISOString().split("T")[0];
  const defaultValuestime = istDate.toISOString();

  return {
      defaultValues,
      defaultValuestime,
  };
}

 // export const Userid :any = localStorage.getItem("useR_ID")?.replace(/^"|"$/g, '');
 
